import { List } from "@/components/flexkit/list/List";
import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";
import { AutomationListItemSkeleton } from "@/components/automations/AutomationListItemSkeleton";

type AutomationListSkeletonProps = PropsWithClassName & {
    count?: number;
};

export const AutomationListSkeleton: FC<AutomationListSkeletonProps> = ({ count = 6, className }) => {
    return (
        <div data-testid="automation-list-skeleton" className={cn(className)}>
            <List aria-label="Loading automations">
                {Array.from({ length: count }).map((_, index) => (
                    <AutomationListItemSkeleton key={index} id={`automation-list-skeleton-${index}`} />
                ))}
            </List>
        </div>
    );
};
